var render = function () {
  var _vm$job$customer;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "position": "relative",
      "height": "84px",
      "padding-top": "4px"
    },
    on: {
      "dragenter": _vm.dragEnter,
      "dragleave": _vm.dragLeave,
      "dragover": _vm.dragOver,
      "drop": _vm.dragDrop
    }
  }, [_c('v-card', {
    staticClass: "mx-1 my-0 jobBlock",
    staticStyle: {
      "height": "80px",
      "user-select": "none"
    },
    attrs: {
      "id": "job-".concat(_vm.job.xid),
      "draggable": "true"
    },
    on: {
      "dragstart": _vm.dragStart,
      "click": _vm.leftClick,
      "contextmenu": function contextmenu($event) {
        $event.preventDefault();
        return function (e) {
          return _vm.$emit('rightClick', e);
        }.apply(null, arguments);
      },
      "dblclick": _vm.dblClick
    }
  }, [_c('v-card-text', {
    ref: "cardText",
    staticStyle: {
      "pointer-events": "none"
    }
  }, [_c('v-row', {
    staticClass: "pt-1"
  }, [_c('v-col', {
    staticClass: "py-0 text-truncate",
    attrs: {
      "cols": "9"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold primary--text"
  }, [_vm._v(_vm._s(_vm.job.number))])]), _c('v-col', {
    staticClass: "py-0 text-right text-truncate text-caption",
    attrs: {
      "cols": "3"
    }
  }, [_vm.job.date_promised ? _c('span', [_vm._v("Forecast " + _vm._s(_vm.moment(_vm.job.date_promised).fromNow()))]) : _vm.job.date_accepted ? _c('span', [_vm._v("Accepted " + _vm._s(_vm.moment(_vm.job.date_accepted).fromNow()))]) : _vm.job.date_enquired ? _c('span', [_vm._v("Enquired " + _vm._s(_vm.moment(_vm.job.date_enquired).fromNow()))]) : _c('span', [_vm._v("Created " + _vm._s(_vm.moment(_vm.job.created_at).fromNow()))])]), _c('v-col', {
    staticClass: "py-0 text-truncate",
    attrs: {
      "cols": "9"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s((_vm$job$customer = _vm.job.customer) === null || _vm$job$customer === void 0 ? void 0 : _vm$job$customer.name))]), _vm.job.customer_acc ? _c('span', {
    staticClass: "mr-4"
  }, [_vm._v(" - " + _vm._s(_vm.job.customer_acc))]) : _vm._e()]), _c('v-col', {
    staticClass: "py-0 text-right text-truncate text-caption",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-chip', {
    staticClass: "ml-2 mb-0",
    staticStyle: {
      "position": "relative",
      "top": "-2px"
    },
    attrs: {
      "label": "",
      "x-small": ""
    }
  }, [_vm._v(_vm._s(_vm.job.stage.title))])], 1), _c('v-col', {
    staticClass: "py-0 text-truncate",
    attrs: {
      "cols": "9"
    }
  }, [_vm._v(_vm._s(_vm.job.description))]), _c('v-col', {
    staticClass: "py-0 text-right text-truncate text-caption",
    attrs: {
      "cols": "3"
    }
  }, [_vm._v(" " + _vm._s(_vm.job.tasks_complete) + " / " + _vm._s(_vm.job.tasks_total) + " ")])], 1)], 1)], 1), _c('div', {
    staticClass: "indicator",
    class: {
      'dragTop': _vm.dragover && _vm.dragPos == 'before',
      'dragBottom': _vm.dragover && _vm.dragPos == 'after'
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }